<script>
	import Header from './components/Header.svelte';
	import Footer from './components/Footer.svelte';
	import Tabs from './shared/Tabs.svelte';
	import CreatePollForm from './components/CreatePollForm.svelte';
import PollList from './components/PollList.svelte';
import PollStore from './stores/PollStore.js';

	let items = ["Current Polls", "Create Poll"];
	let activeItem = "Current Polls";

	const tabChange = (e) => {
		activeItem = e.detail;
	};

	const handleAdd = (e) => {
		const poll = e.detail;
		// update the central PollStore so all subscribers (PollList) receive the new poll
		PollStore.update(list => [poll, ...list]);
		activeItem = 'Current Polls';
	};
</script>

<Header />
<main>
	<Tabs {activeItem} {items}  on:tabChange={tabChange} />

	{#if activeItem === "Current Polls"}
		<PollList />
	{:else if activeItem === "Create Poll"}
		<CreatePollForm on:add={handleAdd}/>
	{/if}
	
</main>
<Footer />

<style>
	main {
		max-width: 960px;
		margin: 40px auto;
		padding-bottom: 80px; /* ensure content isn't hidden behind fixed footer */
	}
</style>